
<template>
  <ClientOnly>
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex">
          <HederLogo />
          <button
            type="button"
            class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
            id="vertical-menu-btn"
            @click="toggleMenu"
            aria-label="Otvori meni"
          >
            <i class="esei icon-bars"></i>
          </button>
        </div>

        <div class="d-flex">
          <Profile @logoutUser="logoutUser" />
        </div>
      </div>
    </header>
  </ClientOnly>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRuntimeConfig, navigateTo } from '#imports'

import { LanguagesWithFlag } from '~/components/leyoutsCustomer/utils/topBar.js'
import HederLogo from '~/components/leyoutsCustomer/common/HeaderLogo.vue'
import AppSearch from '~/components/leyoutsCustomer/common/AppSearch.vue'
import MobileAppSearch from '~/components/leyoutsCustomer/common/MobileAppSearch.vue'
import LanguageDropdown from '~/components/leyoutsCustomer/common/LanguageDropdown.vue'
import AppList from '~/components/leyoutsCustomer/common/AppList.vue'
import Notifications from '~/components/leyoutsCustomer/common/Notifications.vue'
import Profile from '~/components/leyoutsCustomer/common/Profile.vue'

const emit = defineEmits(['toggleMenu', 'toggleRightSidebar'])

const config = useRuntimeConfig()
const locale = ref('sr')

const languages = LanguagesWithFlag

const current_language = ref('en')
const text = ref(null)
const flag = ref(null)
const value = ref(null)

onMounted(() => {
  value.value = languages.find(x => x.language === 'en') || languages[0] || null
  if (value.value) {
    text.value = value.value.title
    flag.value = value.value.flag
  }
})

const toggleMenu = () => {
 
  
  document.body.classList.toggle('sidebar-enable')

  const isDesktop = window.innerWidth >= 992

  // očisti prethodni hook ako postoji
  if (typeof removeAfterEach === 'function') {
    removeAfterEach()
    removeAfterEach = null
  }

  if (isDesktop) {
    document.body.classList.toggle('vertical-collpsed')

    removeAfterEach = router.afterEach(() => {
      document.body.classList.remove('sidebar-enable')
      document.body.classList.remove('vertical-collpsed')
    })
  } else {
    document.body.classList.remove('vertical-collpsed')

    removeAfterEach = router.afterEach(() => {
      document.body.classList.remove('sidebar-enable')
    })
  }

  // ako u store-u imaš isMenuCondensed
  if ('isMenuCondensed' in layoutStore) {
    layoutStore.isMenuCondensed = !layoutStore.isMenuCondensed
  }
}

const toggleRightSidebar = () => {
  emit('toggleRightSidebar')
}

const setLanguage = (data) => {
  const { language, country, flag: f } = data
  locale.value = language
  current_language.value = language
  text.value = country
  flag.value = f
}

const initFullScreen = () => {
  document.body.classList.toggle('fullscreen-enable')

  const docEl = document.documentElement

  const isFs =
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement

  if (!isFs) {
    if (docEl.requestFullscreen) docEl.requestFullscreen()
    else if (docEl.mozRequestFullScreen) docEl.mozRequestFullScreen()
    else if (docEl.webkitRequestFullscreen) docEl.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
  } else {
    if (document.exitFullscreen) document.exitFullscreen()
    else if (document.cancelFullScreen) document.cancelFullScreen()
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen()
  }
}

const logoutUser = () => {
  const auth = config.public?.auth
  // ovde ostaviš svoje logike ako je firebase/fakebackend
  // if (auth === 'firebase') {}
  // else if (auth === 'fakebackend') {}

  navigateTo({ path: '/login' })
}
</script>



 
